import { RealTimeSttHearingHeader, RealTimeSttPause, RealTimeSttTranscriptDivider } from '../lib'
import { RealTimeSttRemarkWithMetadata } from './real-time-stt-remark-with-metadata'
import {
  RealTimeSttTranscriptElementBase,
  RealTimeSttTranscriptElementType,
} from './real-time-stt-transcript-element-base'

export interface RealTimeSttMetadata {
  isSealed: boolean
  segmentId: string
}

// Ensure all our transcript elements correctly implement the ElementBase
type EnforceExtends<T extends RealTimeSttTranscriptElementBase & { type: RealTimeSttTranscriptElementType }> = T
export type RealTimeSttTranscriptElement =
  | EnforceExtends<RealTimeSttPause>
  | EnforceExtends<RealTimeSttRemarkWithMetadata>
  | EnforceExtends<RealTimeSttTranscriptDivider>
  | EnforceExtends<RealTimeSttHearingHeader>

export type RealTimeSttTranscriptElementWithMetadata = RealTimeSttTranscriptElement & RealTimeSttMetadata

export function isSealedContentMarker(element: RealTimeSttTranscriptElement): element is RealTimeSttRemarkWithMetadata {
  return isRemark(element) && !!element.isSealedContentMarker
}

export function isTranscriptDivider(
  element: RealTimeSttTranscriptElement,
): element is RealTimeSttTranscriptDivider & RealTimeSttMetadata {
  return element.type === 'Divider'
}

export function isHearingHeader(
  element: RealTimeSttTranscriptElement,
): element is RealTimeSttHearingHeader & RealTimeSttMetadata {
  return element.type === 'HearingHeader'
}

export function isPause(element: RealTimeSttTranscriptElement): element is RealTimeSttPause & RealTimeSttMetadata {
  return element.type === 'Pause'
}

export function isRemark(element: RealTimeSttTranscriptElement): element is RealTimeSttRemarkWithMetadata {
  return element.type === 'Remark'
}
